import { render, staticRenderFns } from "./language-button.vue?vue&type=template&id=6ebb01af"
import script from "./language-button.ts?vue&type=script&lang=js&external"
export * from "./language-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports